import { AwardItem, CampaignAwards } from '@yandex-int/k-common';

export const getFirstAwardByCampaignSlug = (campaignAwards: CampaignAwards[], campaignSlug: string) => {
    const awardItems =
        campaignAwards.find((campaignAward) => campaignAward.campaign.slug === campaignSlug)?.award_items || [];

    return awardItems[0]?.award;
};

export type CertificateInfo =
    | {
          certificate: string;
          template: null | undefined;
          args: null | undefined;
      }
    | {
          certificate: null | undefined;
          template: string;
          args: Record<string, unknown>;
      };

export const getCertificatesFromAwards = (awardItems: AwardItem[]) => {
    const result: Record<number, CertificateInfo> = {};

    awardItems.forEach((awardItem) => {
        if (awardItem.certificates) {
            awardItem.certificates.forEach(
                ({ user, certificate, certificate_template: template, context_json: args }) => {
                    result[user] = { certificate, template, args } as CertificateInfo;
                }
            );
        }
    });

    return result;
};
